import { styled } from 'styled-components';

import { MainContent } from '../containers/MainContent/MainContent';
import { SideBar } from '../containers/SideBar/SideBar';
import { TopBar } from '../containers/TopBar/TopBar';

const StyledPageWrapper = styled.div`
  container-type: inline-size;
  container-name: app;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100dvw;
`;

const StyledMainColumn = styled.div`
  ${({ theme }) => `
  display: flex;
  height: calc(100% - ${theme.controlHeightLG * 1.25}px);
  width: 100%;
  min-width: ${theme.screenXSMin / 1.5}px;

  @container app (width >= ${theme.screenXS}px) {
    height: 100%;
  }
`}
`;

export const MainLayout = () => {
  return (
    <StyledPageWrapper>
      <TopBar />
      <StyledMainColumn>
        <SideBar />
        <MainContent />
      </StyledMainColumn>
    </StyledPageWrapper>
  );
};
